import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { AccessDeniedService } from '../../services/access-denied/access-denied.service';
import { DestroyBase } from '../../base-classes/destroy-component-base';

@Component({
  selector: 'app-access-denied-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './access-denied-modal.component.html',
  styleUrl: './access-denied-modal.component.scss',
})
export class AccessDeniedModalComponent extends DestroyBase implements OnInit {
  private accessDeniedService = inject(AccessDeniedService);
  private router = inject(Router);

  isOpen = false;
  message = '';

  ngOnInit(): void {
    this.accessDeniedService.isOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen) => {
        this.isOpen = isOpen;
      });
    this.accessDeniedService.message$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        this.message = message;
      });
  }

  onOk(): void {
    this.accessDeniedService.close();
    this.router.navigate(['/dashboard']);
  }
}
